// Témoignages réels uniquement — JAMAIS d'avis inventé
// visible: false = en attente de validation
// Ajouter un témoignage = ajouter un objet ici

export const temoignages = [];
// Tableau vide au départ — la section sera masquée automatiquement
